import { useQuery } from '@tanstack/react-query';
import {
  getClientRegistrationSummary,
  getPlateRegistrationHistory
} from '../requests/plateRegistration.request';

export const clientRegistrationSummaryKey = (clientId?: string) => [
  'plate-registration-summary',
  clientId
];

export const usePlateRegistrationSummaryQuery = (clientId?: string) => {
  return useQuery({
    queryKey: clientRegistrationSummaryKey(clientId),
    queryFn: () => getClientRegistrationSummary(clientId as string),
    enabled: !!clientId
  });
};

export const usePlateRegistrationHistoryQuery = (plateId?: string, enabled = true) => {
  return useQuery({
    queryKey: ['plate-registration-history', plateId],
    queryFn: () => getPlateRegistrationHistory(plateId as string),
    enabled: !!plateId && enabled
  });
};
